<template>
  <div class="wrap" :data-disabled="disabled ? '1' : '0'">
    <button
      class="switch"
      type="button"
      role="switch"
      :aria-checked="modelValue ? 'true' : 'false'"
      :disabled="disabled"
      @click="onToggle"
      @keydown.enter.prevent="onToggle"
      @keydown.space.prevent="onToggle"
    >
      <span class="track" aria-hidden="true">
        <span class="knob" aria-hidden="true"></span>
      </span>
    </button>
    <span v-if="label" class="label">{{ label }}</span>
  </div>
</template>

<script setup>
const props = defineProps({
  modelValue: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  label: { type: String, default: '' },
})

const emit = defineEmits(['update:modelValue'])

function onToggle() {
  if (props.disabled) return
  emit('update:modelValue', !props.modelValue)
}
</script>

<style scoped>
.wrap {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  user-select: none;
}

.switch {
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
}

.switch:disabled {
  cursor: not-allowed;
}

.track {
  width: 44px;
  height: 22px;
  border-radius: 999px;
  border: 1px solid var(--border);
  background: var(--badge-bg);
  position: relative;
  display: inline-block;
}

.knob {
  width: 18px;
  height: 18px;
  border-radius: 999px;
  background: var(--muted);
  border: 1px solid var(--border);
  position: absolute;
  top: 1px;
  left: 1px;
  transition: transform 120ms ease, background 120ms ease;
}

.switch[aria-checked='true'] .track {
  background: rgba(0, 147, 218, 0.18);
  border-color: rgba(0, 147, 218, 0.35);
}

.switch[aria-checked='true'] .knob {
  transform: translateX(22px);
  background: var(--accent);
  border-color: rgba(0, 147, 218, 0.35);
}

.switch:disabled {
  opacity: 0.6;
}

.label {
  color: var(--muted);
  font-size: 13px;
  font-weight: 600;
}
</style>
